import React, { Component } from 'react';
import axios from 'axios';
import './styles/App.css';
// import Cookies from 'universal-cookie';
import isURL from 'validator/lib/isURL';

class Suggest extends Component {
  constructor(props) {
    super(props);

    // const cookies = new Cookies();

    this.state = {
      description: "",
      link: "",
      valid: false
      // csrf_token: cookies.get("csrftoken"),
    }

    this.submit = this.submit.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.handleLinkChange = this.handleLinkChange.bind(this);
  }

  handleDescriptionChange(event) {
    this.setState({ description: event.target.value });
  }

  handleLinkChange(event) {
    var link = event.target.value;
    this.setState({ link: link, valid: isURL(link) });
  }

  submit(event) {
    event.preventDefault();

    axios.post(process.env.REACT_APP_API + '/api/suggestion/', { description: this.state.description, link: this.state.link })
    .then((response) => {
      this.setState({ link: "", description: "", valid: false });
      alert(response.data);
    })
    .catch((error) => {
      alert("An error occurred. We apologize for the inconvenience!");
    });
  }

  render() {
    return (
      <div className="suggest-div">
      <form onSubmit={this.submit}>
      <h2>Suggest a Model</h2>
      <p>Got a model that you think we should include? Let us know!</p>
      <hr/>
      
      <div className="form-group">
      <label htmlFor="suggestion-description">Description</label>
      <input type="text" className="form-control" id="suggestion-description" placeholder="Enter a short description of this model." value={this.state.description} onChange={this.handleDescriptionChange} />
      </div>

      <div className="form-group">
      <label htmlFor="suggestion-link">Link *</label>
      <input required type="text" className={"form-control " + (this.state.link.length === 0 ? "" : (this.state.valid ? "is-valid" : "is-invalid"))} id="suggestion-link" placeholder="https://github.com/" value={this.state.link} onChange={this.handleLinkChange} />
      { this.state.link.length === 0 ?
        "" :
        <div className={ this.state.valid ? "valid-feedback" : "invalid-feedback" }>
        { this.state.valid ? "Looks good!" : "Please enter a valid URL!" }
        </div>
      }
      </div>

      <div align="center">
      <input className="btn btn-primary" type="submit" disabled={!this.state.valid} value="Submit"/>
      </div>
      </form>
      </div>
    )
  }
}

export default Suggest;


// WEBPACK FOOTER //
// ./src/Suggest.jsx